module.exports = __webpack_public_path__ + "img/cross.c14371b2.svg";